module.exports = __webpack_public_path__ + "img/fedex.8186e0e8.png";